import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { HeaderComponent } from './header/header.component';
import {FlexLayoutModule} from '@angular/flex-layout';
import {FreightSharedModule} from '../freight-shared/freight-shared.module';
import { SiteMenuComponent } from './site-menu/site-menu.component';
import {MenubarModule} from 'primeng/menubar';
import {InputTextModule} from 'primeng/inputtext';
import {SharedModule} from 'primeng/api';
import {FontAwesomeModule} from '@fortawesome/angular-fontawesome';
import { UserLoginSectionComponent } from './user-login-section/user-login-section.component';
import {MatIconModule} from '@angular/material/icon';
import {ButtonModule} from 'primeng/button';
import {MenuModule} from 'primeng/menu';
import {ToastModule} from 'primeng/toast';
import {TranslateModule} from '@ngx-translate/core';
import {NgSelectModule} from '@ng-select/ng-select';



@NgModule({
  declarations: [HeaderComponent, SiteMenuComponent, UserLoginSectionComponent],
    exports: [
        HeaderComponent,
        SiteMenuComponent
    ],
    imports: [
        CommonModule,
        FormsModule,
        FlexLayoutModule,
        FreightSharedModule,
        MenubarModule,
        InputTextModule,
        SharedModule,
        FontAwesomeModule,
        MatIconModule,
        ButtonModule,
        MenuModule,
        ToastModule,
        TranslateModule,
        NgSelectModule
    ]
})
export class HeaderModule { }
